import type { Stop } from '../../content/routes';
import { activeRoute, directionOf, worldS } from '../../world/route';

/** Half-length of the yellow stop box, metres. */
export const STOP_BOX_HALF = 8;

export interface StopPoint {
  seq: number;
  stop: Stop;
  /** Absolute distance of the box centre along the road. */
  position: number;
  trip: number;
  /** The terminus at the end of this trip: everyone gets down, nobody boards (they board after the U-turn). */
  isTripEnd: boolean;
}

export function stopsPerTrip(): number {
  return activeRoute().stops.length;
}

/** seq counts stops from the start of the shift; each trip visits the route's stops in driving order. */
export function stopAt(seq: number): StopPoint {
  const { stops } = activeRoute();
  const count = stops.length;
  const trip = Math.floor(seq / count);
  const index = seq % count;
  const stop = directionOf(trip) === 'out' ? stops[index] : stops[count - 1 - index];
  if (!stop) throw new Error(`no stop for seq ${seq}`);
  return { seq, stop, position: worldS(trip, stop.at), trip, isTripEnd: index === count - 1 };
}

/** The terminus of the trip that `seq` belongs to. Nobody rides past it. */
export function lastSeqOfTrip(seq: number): number {
  const count = stopsPerTrip();
  return Math.floor(seq / count) * count + count - 1;
}

export function isInsideBox(busS: number, point: StopPoint, busLength: number): boolean {
  return Math.abs(busS - point.position) <= STOP_BOX_HALF - busLength / 4;
}
